var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"impact-page"}},[_c('LandingBanner'),_c('PrimaryImpact',{attrs:{"odsStats":_vm.odsStats,"isMounted":_vm.isMounted,"odsSelected":_vm.targetId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }